import BaseComponent from '../base-component/base-component'
import { checkEnterKey } from '../../utils/utils'
import Modal from './modal'

class ModalCloseBtn extends BaseComponent {
  connectedCallback(): void {
    this.addEventListener('keydown', this.handleKeyDown)
    this.addEventListener('click', this.handleButtonClick)
  }

  disconnectedCallback(): void {
    this.removeEventListener('keydown', this.handleKeyDown)
    this.removeEventListener('click', this.handleButtonClick)
  }

  handleButtonClick = (): void => {
    this.hide()
  }

  handleKeyDown = (event: KeyboardEvent): void => {
    const isEnterKey = checkEnterKey(event.key || event.keyCode)

    if (isEnterKey) {
      event.preventDefault()

      this.hide()
    }
  }

  hide(): void {
    const modal = document.querySelector<Modal>(this.dataset.modal)

    if (modal) {
      modal.hide()
    }
  }
}

export default ModalCloseBtn
